import styles from "./styles.module.css";
import Container from "../Container";
import Button from "../Button";
import { ArrowLink } from "../Icons";
import Heading from "../Heading";
import Image from "next/image";
import Link from "next/link";
import MyImage from "../MyImage";

const ResourceAuthorsItem = ({ avatarUrl, name, description, website }) => {
  return (
    <div className={styles.author}>
      <div className={styles.avatarWrapper}>
        {!!avatarUrl && (
          <MyImage
            src={avatarUrl}
            width="86"
            height="86"
            layout="intrinsic"
            objectFit="cover"
            alt="avatar"
          />
        )}
      </div>
      <div className={styles.info}>
        {website ? (
          <h3 className={styles.name}>
            <Link href={website} passHref>
              <a className={styles.nameLink}>
                {name} <ArrowLink fill="var(--black)" />
              </a>
            </Link>
          </h3>
        ) : (
          <h3 className={styles.name}>{name}</h3>
        )}
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );
};

const ResourceAuthors = ({
  authors = [],
  participants = [],
  podcasts = [],
  presenters = [],
  sponsors = [],
  partners = [],
  sources = [],
  resourceType,
  ...rest
}) => {
  const heading =
    resourceType === "news-feature" || resourceType === "press-release"
      ? "Featured"
      : "About the author";
  return (
    <div className={styles.resourceAuthors} id="authors">
      {authors && !!authors.length && resourceType !== "podcast" && (
        <div className={styles.group}>
          <Heading>{heading}</Heading>
          {authors.map((author, index) => (
            <ResourceAuthorsItem
              key={index}
              website={author.website}
              avatarUrl={author.avatar?.node?.sourceUrl}
              name={author.name}
              description={author.description}
            />
          ))}
        </div>
      )}
      {participants && !!participants.length && (
        <div className={styles.group}>
          <Heading>About the participant</Heading>
          {participants.map((participant, index) => (
            <ResourceAuthorsItem
              key={index}
              website={participant.website}
              avatarUrl={participant.avatar?.node?.sourceUrl}
              name={participant.name}
              description={participant.description}
            />
          ))}
        </div>
      )}
      {presenters && !!presenters.length && (
        <div className={styles.group}>
          <Heading>About the presenters</Heading>
          {presenters.map((presenter, index) => (
            <ResourceAuthorsItem
              key={index}
              website={presenter.website}
              avatarUrl={presenter.avatar?.node?.sourceUrl}
              name={presenter.name}
              description={presenter.description}
            />
          ))}
        </div>
      )}
      {sponsors && !!sponsors.length && (
        <div className={styles.group}>
          <Heading>About the sponsor</Heading>
          {sponsors.map((sponsor, index) => (
            <ResourceAuthorsItem
              key={index}
              website={sponsor.website}
              avatarUrl={sponsor.avatar?.node?.sourceUrl}
              name={sponsor.name}
              description={sponsor.description}
            />
          ))}
        </div>
      )}
      {partners && !!partners.length && (
        <div className={styles.group}>
          <Heading>About the sponsor</Heading>
          {partners.map((partner, index) => (
            <ResourceAuthorsItem
              key={index}
              website={partner.website}
              avatarUrl={partner.avatar?.node?.sourceUrl}
              name={partner.name}
              description={partner.description}
            />
          ))}
        </div>
      )}
      {podcasts && !!podcasts.length && (
        <div className={styles.group}>
          <Heading>About the podcast</Heading>
          {podcasts.map((podcast, index) => (
            <ResourceAuthorsItem
              key={index}
              website={podcast.website}
              avatarUrl={podcast.avatar?.node?.sourceUrl}
              name={podcast.name}
              description={podcast.description}
            />
          ))}
        </div>
      )}
      {sources && !!sources.length && (
        <div className={styles.group}>
          <Heading>About the source</Heading>
          {sources.map((source, index) => (
            <ResourceAuthorsItem
              key={index}
              website={source.website}
              avatarUrl={source.avatar?.node?.sourceUrl}
              name={source.name}
              description={source.description}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ResourceAuthors;
